<template>
    <div class="content-wrapper">
        <div class="container-lg">
            <div class="row mb-12">
                <div class="col">
                    <div class="page-title-nav row">
                        <div class="col-2 col-lg-3">
                            <router-link :to="`/member/home`" class="btn btn-outline-secondary btn-custom btn-back">
                                <i class="fa-icon fa-regular fa-arrow-left me-0"></i><span
                                    class="d-none d-lg-block ms-2">ย้อนกลับ</span>
                            </router-link>
                        </div>
                        <div class="col-8 col-lg-6">
                            <h1 class="page-title">เติมเงิน</h1>
                        </div>
                        <div class="col-12 col-lg-3">
                            <a href="#" class="btn btn-primary btn-custom d-none"><i
                                    class="fa-icon fa-regular fa-home"></i><span>button</span></a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="alert alert-warning d-flex" role="alert">
                                <i class="fa-icon fa-solid fa-circle-info mt-1 me-2"></i>กรุณาเลี่ยงการเติมเงินช่วงเวลา
                                00:00น.
                                (เที่ยงคืน) เนื่องจากระบบธนาคารไม่สามารถตรวจสอบยอดเงินได้
                            </div>
                            <div class="content-card mb-4">
                                <div class="content-card-title">
                                    เลือกช่องทางเติมเงิน {{ getDepositMode }}
                                </div>
                                <div class="content-card-body">
                                    <div
                                        class="d-flex flex-md-row flex-column align-items-center justify-content-center column-gap-4">
                                        <div class="col-12 col-md-3 d-grid">

                                            <router-link v-if="Number(getDepositMode) === Number(1)" :to="''"
                                            class="btn btn-outline-secondary btn-xl flex-column   disable-deposit" >
                                            <i class="payment-icon icon-transfer mb-4 mt-2"></i>
                                            เติมเงินอัตโนมัติ ยังไม่เปิดให้บริการ
                                            </router-link>
                                            <router-link v-else  :to="`/member/depositpromptpay`"
                                            class="btn btn-outline-secondary btn-xl flex-column">
                                            <i class="payment-icon icon-transfer mb-4 mt-2"></i>
                                            เติมเงินอัตโนมัติ
                                            </router-link>
                                        </div>
                                        <span class="my-2">หรือ</span>
                                        <div  class="col-12 col-md-3 d-grid">
                                            <router-link :to="`/member/deposittransfer1`" v-if="Number(getDepositMode) === Number(1)"
                                            class="btn btn-outline-secondary btn-xl flex-column">
                                            <i class="payment-icon icon-pp mb-4 mt-2"></i>
                                            เติมเงินเเนบสลิป
                                            </router-link>
                                            <router-link :to="``" v-else
                                            class="btn btn-outline-secondary btn-xl flex-column disable-deposit">
                                            <i class="payment-icon icon-pp mb-4 mt-2"></i>
                                            เติมเงินเเนบสลิป ยังไม่เปิดให้บริการ
                                            </router-link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <app-transaction />
                        </div>
                    </div>
                </div>
            </div>
            <div class="push"></div>
        </div>
    </div>
</template>
<script>

import { mapState, mapGetters } from 'vuex'
import transaction from '@/components/sakha/transaction/mainPage'
import { isEmpty } from '@/utils/'
import { STATUS_SUCCESS } from '@/constants'
import { depositCachViewService } from '@/services'
import moment from 'moment-timezone'
export default {
  components: {
    'app-transaction': transaction
  },
  data: () => {
    return {
      modalShow: false,
      confirmDeposit: false
    }
  },
  async mounted () {
    await this.setLoading(true)
    await this.reqConfig(process.env.VUE_APP_AG_ID)
    // if (Number(this.getDepositMode) === Number(1)) {
    //   this.$router.replace('/member/depositP')
    // }
    this.adminListBank = await this.inquiryListBank()
    await this.getMyAccountBanks()
    const resp = await depositCachViewService()
    if (resp.status_code === STATUS_SUCCESS) {
      if (isEmpty(resp.data) === false) {
        this.amount = resp.data.amount
        this.confirmDeposit = true
        this.adminBank = resp.data.bankInfo
        this.timer = setInterval(() => {
          this.getMyStagementDep()
        }, this.timeInterval)
      }
    }
    for (let i = 0; i < 10; i++) { // 10 minute after Asia/Bangkok
      const timePush = moment().tz('Asia/Bangkok').add(i, 'minute').format('HH:mm')
      this.time_ban.push(timePush)
    }
    await this.setLoading(false)
  },
  computed: {
    ...mapState({
      hasBank: state => state.bankModule.hasBank
    }),
    ...mapGetters(['getDepositMode', 'getBalance', 'getUsername', 'getIsActive', 'getUsetAgentId']),
    iconsFlags: function () {
      return this.language === 'th' ? 'flag-icon flag-icon-th' : 'flag-icon flag-icon-gb'
    },
    settingBank () {
      return this.hasBank ? '/member/settings/bank' : '/member/settings/bank/add'
    },
    getVip () {
      return this.$store.getters.getVip
    },
    getIsVip () {
      return this.$store.getters.getIsVip
    }
  }
}
</script>
<style>

.disable-deposit {
  opacity: 1;
  background-color: #a0a0a0;
  color: black;
}
</style>
